import React from "react"

export const Design = ({ style, color, fill, className }) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 72 72"
    fill={fill}
    style={style}
    className={className}
  >
    <g id="design" className="st0">
      <g className="st1">
        <path d="M23,30.9c0-1.8,0.3-3.6,0.8-5.2H13v32.4h32.4V47c-1.7,0.6-3.5,0.9-5.4,0.9C30.6,47.9,23,40.3,23,30.9z" />
        <path d="M57,30.9c0-9.4-7.6-17-17-17c-7.6,0-14,5-16.2,11.8h21.6V47C52.1,44.7,57,38.4,57,30.9z" />
      </g>
      <path
        style={{ opacity: 0.15 }}
        className="st2"
        d="M59.2,69.8H13.1C7.1,69.8,2.2,64.9,2.2,59V12.8C2.2,6.9,7.1,2,13.1,2h46.2C65.1,2,70,6.9,70,12.8V59
		C70,64.9,65.1,69.8,59.2,69.8z"
      />
    </g>
  </svg>
)

export const Share = ({ style, color, fill, className }) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 72 72"
    fill={fill}
    style={style}
    className={className}
  >
    <g id="share" className="st0">
      <path
        style={{ opacity: 0.15 }}
        className="st2"
        d="M59.2,69.8H13.1C7.1,69.8,2.2,64.9,2.2,59V12.8C2.2,6.9,7.1,2,13.1,2h46.2C65.1,2,70,6.9,70,12.8V59
		C70,64.9,65.1,69.8,59.2,69.8z"
      />
      <path
        className="st1"
        d="M35,12.5c-4.3,0-7.8,3.4-7.9,7.7C19.9,23.2,15,30.4,15,38.5c0,0.3,0,0.7,0,1.1c-2.4,1.4-4,3.9-4,6.9
		c0,4.4,3.6,8,8,8c1.1,0,2.3-0.2,3.2-0.7c3.5,2.9,8,4.7,12.8,4.7s9.3-1.8,12.8-4.7c1,0.4,2.1,0.7,3.2,0.7c4.4,0,8-3.6,8-8
		c0-3-1.7-5.6-4.1-6.9c0-0.3,0.1-0.6,0.1-1.1c0-8.1-4.9-15.3-12.1-18.3C42.8,15.9,39.3,12.5,35,12.5z M35,16.5c2.2,0,4,1.8,4,4
		s-1.8,4-4,4s-4-1.8-4-4S32.8,16.5,35,16.5z M27.9,24.2c1.3,2.5,4,4.3,7.1,4.3s5.7-1.8,7.1-4.3c5.4,2.6,8.9,8.1,8.9,14.3
		c-4.4,0-8,3.6-8,8c0,1.8,0.6,3.4,1.6,4.8c-2.7,2-6.1,3.2-9.6,3.2s-6.9-1.2-9.6-3.2c1-1.3,1.6-3,1.6-4.8c0-4.4-3.6-8-8-8
		C19,32.3,22.6,26.8,27.9,24.2z M19,42.5c2.2,0,4,1.8,4,4s-1.8,4-4,4s-4-1.8-4-4S16.8,42.5,19,42.5z M51,42.5c2.2,0,4,1.8,4,4
		s-1.8,4-4,4s-4-1.8-4-4S48.8,42.5,51,42.5z"
      />
    </g>
  </svg>
)
export const Code = ({ style, color, fill, className }) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 72 72"
    style="enable-background:new 0 0 72 72;"
    fill={fill}
    style={style}
    className={className}
  >
    <g id="code">
      <path
        style={{ opacity: 0.15 }}
        className="st3"
        d="M59.2,69.8H13.1C7.1,69.8,2.2,64.9,2.2,59V12.8C2.2,6.9,7.1,2,13.1,2h46.2C65.1,2,70,6.9,70,12.8V59
		C70,64.9,65.1,69.8,59.2,69.8z"
      />
      <polygon points="23.7,23.6 26.7,27 15.5,35.1 26.7,43.2 23.7,46.9 10.6,36.8 10.6,33.2 	" />
      <polygon points="38.1,18.3 42.8,18.3 32.7,50.8 28.2,50.8 	" />
      <polygon points="47.3,23.6 44.2,27 55.4,35.1 44.2,43.2 47.3,46.9 60.3,36.8 60.3,33.2 	" />
    </g>
  </svg>
)
export const Twitter = ({ style, color, fill, className }) => (
  <svg
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 612 612"
    fill={fill}
    style={style}
    className={className}
  >
    <g>
      <path d="M612,116.258c-22.525,9.981-46.694,16.75-72.088,19.772c25.929-15.527,45.777-40.155,55.184-69.411
			c-24.322,14.379-51.169,24.82-79.775,30.48c-22.907-24.437-55.49-39.658-91.63-39.658c-69.334,0-125.551,56.217-125.551,125.513
			c0,9.828,1.109,19.427,3.251,28.606C197.065,206.32,104.556,156.337,42.641,80.386c-10.823,18.51-16.98,40.078-16.98,63.101
			c0,43.559,22.181,81.993,55.835,104.479c-20.575-0.688-39.926-6.348-56.867-15.756v1.568c0,60.806,43.291,111.554,100.693,123.104
			c-10.517,2.83-21.607,4.398-33.08,4.398c-8.107,0-15.947-0.803-23.634-2.333c15.985,49.907,62.336,86.199,117.253,87.194
			c-42.947,33.654-97.099,53.655-155.916,53.655c-10.134,0-20.116-0.612-29.944-1.721c55.567,35.681,121.536,56.485,192.438,56.485
			c230.948,0,357.188-191.291,357.188-357.188l-0.421-16.253C573.872,163.526,595.211,141.422,612,116.258z" />
    </g>
  </svg>
)

export const Logo = ({ style, color, fill, className }) => (
  <svg
    version="1.1"
    id="Layer_1"
    x="0px"
    y="0px"
    viewBox="0 0 6783.7 762.9"
    fill={fill}
    style={style}
    className={className}
  >
    <path d="M440.8,617.9c-19.2,10.8-38.5,20.5-59,27.6c-24,8.3-48.6,14.5-74,17.2c-15.1,1.6-29.6-1.9-44.4-4.7
c-17.4-3.4-32.4-11.3-45.3-22.9c-14.4-12.9-25.1-28.4-29.7-47.7c-4.3-18-8.9-35.9-5.9-54.6c2-12.4,4.5-24.8,7.2-37.1
c8.3-37.5,24.6-71.7,44.7-104.2c25.9-42,55.9-80.9,90.1-116.7c22.9-24,47.3-46.3,73.3-67c1.6-1.3,2.8-1.8,4.7-0.7
c13.1,7.7,26.2,15.4,39.9,23.4c-1.7,1.4-2.7,2.2-3.8,3c-61.8,47.6-115,103.4-157.5,169c-20.2,31.2-37.1,64-47.1,100
c-5.2,18.6-7.9,37.5-6,56.9c3.2,31.9,25.7,54.3,57.5,57.3c26.5,2.5,51.5-3.3,76-12.3c11.8-4.3,23.2-9.9,34.9-14.7
c1.3-0.6,3.5-1,4.5-0.3C414.3,598.7,427.3,608.2,440.8,617.9z" />
    <path d="M308.7,401.7c9.7,11.8,18.5,23,27.9,33.8c48.2,55.4,102.7,103.2,166.7,139.7c27.9,15.9,57,28.9,88.6,35.5
c18.8,4,37.8,5.5,56.7,0.2c25.4-7.2,41.5-27.6,44.1-54.7c2.6-26.2-3.3-51-12-75.3c-3.8-10.6-8.7-20.9-13-31.4
c-0.5-1.2-0.9-3.2-0.3-4.1c9.3-13.3,18.8-26.5,28.6-40.1c2.1,3.7,4.1,7.2,6,10.7c18.7,35,30.1,72.4,36.1,111.5
c2.8,18.2-0.9,35.8-4.8,53.5c-3.9,17.9-12.6,32.8-24.8,45.5c-12.5,13-27.4,22.7-45.6,26.9c-17.6,4-35.2,8.7-53.4,5.7
c-13.6-2.2-27.1-5-40.5-8c-36.7-8.4-70.1-24.7-101.8-44.3c-40.4-25.1-78-53.9-112.6-86.6c-24.3-23-46.8-47.6-67.9-73.5
c-2.1-2.6-2.4-4.4-0.6-7.3C293.7,427,301.1,414.5,308.7,401.7z" />
    <path d="M614.3,363.4c-3.2-4.1-5.8-7.4-8.4-10.7c-50.4-62.8-108.7-116.7-178.2-158c-28.9-17.2-59.2-31.3-92.2-38.9
c-19.1-4.4-38.4-6.5-57.8-1.5c-27,6.9-43.8,27.3-46.5,55.6c-2.5,26.2,3.4,51,12.2,75.3c3.7,10.3,8.4,20.2,12.5,30.3
c0.5,1.3,0.5,3.4-0.2,4.4c-9,12.9-18.2,25.6-27.4,38.4c-0.2,0.3-0.6,0.4-1.4,1.1c-5.3-10.9-10.7-21.6-15.7-32.4
c-12.8-27.8-20.1-57.3-25-87.3c-2.8-17.1-0.1-33.7,3.4-50.5c3.9-18.5,11.7-34.7,24.4-48.3c12.9-13.8,28.2-24.3,47.2-28.5
c14.8-3.3,29.5-7.4,45-6.5c16.7,0.9,32.8,5,49,8.8c36.6,8.6,70.1,24.7,101.8,44.4c40.4,25.1,78,53.9,112.6,86.6
c24.1,22.8,46.6,47.1,67.3,73c0.8,1,1.3,3.3,0.8,4.3C630.1,336.3,622.3,349.5,614.3,363.4z" />
    <path d="M484.9,149.2c1.2-0.8,2.3-1.5,3.3-2.1c34.2-19,70.9-30.9,109.3-37.8c20.8-3.7,40.9-1.1,61.2,3.7c18,4.2,33.2,13.1,46,25.6
c14.8,14.3,23.4,32.2,28.4,52.6c6.4,26.4,3.6,51.7-2.1,77.5c-10.9,49.3-33.7,92.9-61.7,134.2c-22.3,32.8-46.9,63.7-74.3,92.4
c-21.1,22-43.4,42.6-66.9,62c-2.7,2.3-4.8,2.8-8,0.9c-12.3-7.5-24.8-14.6-38-22.4c2.1-1.7,3.5-2.9,5-4
c59-46.6,109.9-100.5,150.8-163.7c19.6-30.3,36.1-62.2,46.3-97c5-17,8.2-34.4,7.5-52.2c-0.6-15.2-4.1-29.6-13.6-42
c-11.1-14.4-26.4-21.1-43.9-23.2c-25.9-3.1-50.5,2.8-74.6,11.3c-10.3,3.6-20.2,8.3-30.4,12.4c-1.3,0.5-3.5,0.9-4.5,0.2
C511.5,168.4,498.4,158.9,484.9,149.2z" />
    <path d="M542.1,376.1c-0.1,43.1-35.1,78.1-78.1,77.9c-42.8-0.2-77.7-35.2-77.7-77.9c0-43,35.2-78,78.1-77.8
C507.5,298.5,542.2,333.2,542.1,376.1z" />
    <path d="M1287.4,595L1203,442.2h-67V595h-91.5V165.1h201.1c89.6,0,145,58.6,145,138.6c0,75.4-48.3,116.6-94.7,127.6l97.3,163.7
H1287.4z M1296.4,303c0-35.4-27.7-57.4-63.8-57.4H1136v116h96.7C1268.7,361.7,1296.4,339.8,1296.4,303z" />
    <path d="M1417.6,439c0-90.2,67-163.1,161.1-163.1c93.4,0,156,69.6,156,170.8v19.3h-231.4c5.8,38,36.7,69.6,89.6,69.6
c26.4,0,62.5-11,82.5-30.3l36.7,54.1c-30.9,28.4-79.9,43.2-128.2,43.2C1489.1,602.7,1417.6,538.9,1417.6,439z M1578.7,343
c-50.9,0-72.8,35.4-76,66.4H1656C1653.5,379.7,1632.8,343,1578.7,343z" />
    <path d="M1980.8,595v-32.9c-21.3,25.8-58,40.6-98.6,40.6c-49.6,0-107.6-33.5-107.6-103.1c0-73.5,58-100.5,107.6-100.5
c41.9,0,78,13.5,98.6,38v-39.3c0-31.6-27.1-52.2-68.3-52.2c-32.9,0-63.8,12.9-89.6,36.7l-32.2-57.4c38-34.2,87-49,136-49
c71.5,0,136.6,28.4,136.6,117.9V595H1980.8z M1980.8,520.2v-38.7c-13.5-18-39.3-27.7-65.7-27.7c-32.2,0-58.6,17.4-58.6,47
s26.4,46.4,58.6,46.4C1941.5,547.3,1967.3,538.3,1980.8,520.2z" />
    <path d="M2123.9,439c0-95.4,69.6-163.1,165-163.1c63.8,0,102.5,27.7,123.1,56.1l-53.5,50.3c-14.8-21.9-37.4-33.5-65.7-33.5
c-49.6,0-84.4,36.1-84.4,90.2s34.8,90.9,84.4,90.9c28.4,0,50.9-12.9,65.7-34.2L2412,546c-20.6,28.4-59.3,56.7-123.1,56.7
C2193.5,602.7,2123.9,535,2123.9,439z" />
    <path d="M2482.2,517V355.2h-51.6v-71.5h51.6v-85.1h81.8v85.1h63.2v71.5h-63.2v139.9c0,20,10.3,34.8,28.4,34.8
c12.2,0,23.8-4.5,28.4-9.7l17.4,62.5c-12.2,11-34.2,20-68.3,20C2512.5,602.7,2482.2,573.1,2482.2,517z" />
    <path d="M2850.9,595V165.1h169.5c134.7,0,228.1,85.7,228.1,214.6c0,130.2-93.4,215.3-227.5,215.3H2850.9z M3155,379.7
c0-75.4-46.4-134-134-134h-78.6v268.7h78C3105.4,514.4,3155,453.2,3155,379.7z" />
    <path d="M3291.7,439c0-90.2,67-163.1,161.1-163.1c93.4,0,156,69.6,156,170.8v19.3h-231.4c5.8,38,36.7,69.6,89.6,69.6
c26.4,0,62.5-11,82.5-30.3l36.7,54.1c-30.9,28.4-79.9,43.2-128.2,43.2C3363.2,602.7,3291.7,538.9,3291.7,439z M3452.8,343
c-50.9,0-72.8,35.4-76,66.4h153.4C3527.5,379.7,3506.9,343,3452.8,343z" />
    <path d="M3641,554.4l35.4-59.3c23.2,21.9,69,43.2,107.6,43.2c35.4,0,52.2-13.5,52.2-32.9c0-50.9-184.3-9-184.3-131.5
c0-52.2,45.1-98,127.6-98c52.2,0,94.1,18,125,42.5l-32.9,58c-18.7-19.3-54.1-36.1-92.2-36.1c-29.6,0-49,12.9-49,30.3
c0,45.8,185,7.1,185,132.8c0,57.4-49,99.2-135.3,99.2C3726,602.7,3673.8,584.7,3641,554.4z" />
    <path d="M3967.7,201.2c0-27.1,21.9-48.3,48.3-48.3c27.1,0,49,21.3,49,48.3c0,27.1-21.9,49-49,49
C3989.6,250.2,3967.7,228.3,3967.7,201.2z M3975.4,595V283.7h81.8V595H3975.4z" />
    <path d="M4132,674.9l36.7-58.6c25.1,27.1,58.6,38,97.3,38c39.3,0,86.4-16.8,86.4-79.9v-30.3c-24.5,30.9-58,48.3-96.7,48.3
c-77.3,0-137.3-54.1-137.3-157.9c0-101.8,58.6-158.5,137.3-158.5c37.4,0,71.5,15.5,96.7,47.7v-40h81.8v290.7
c0,117.9-91.5,146.9-168.2,146.9C4213.2,721.3,4171.3,709,4132,674.9z M4352.4,484.8V383.6c-14.2-20-43.8-34.8-70.2-34.8
c-47,0-79.3,32.2-79.3,85.7c0,53.5,32.2,85.7,79.3,85.7C4308.6,520.2,4338.3,504.8,4352.4,484.8z" />
    <path d="M4725.6,595V406.8c0-43.2-22.6-58-57.4-58c-32.2,0-56.7,18-70.9,36.1V595h-81.8V283.7h81.8v40c20-23.2,58.6-47.7,108.9-47.7
c69,0,101.8,38.7,101.8,99.2V595H4725.6z" />
    <path d="M4868.6,439c0-90.2,67-163.1,161.1-163.1c93.4,0,156,69.6,156,170.8v19.3h-231.4c5.8,38,36.7,69.6,89.6,69.6
c26.4,0,62.5-11,82.5-30.3l36.7,54.1c-30.9,28.4-79.9,43.2-128.2,43.2C4940.2,602.7,4868.6,538.9,4868.6,439z M5029.8,343
c-50.9,0-72.8,35.4-76,66.4h153.4C5104.5,379.7,5083.9,343,5029.8,343z" />
    <path d="M5245,595V283.7h81.8v41.9c22.6-27.1,60.6-49.6,99.2-49.6v79.9c-5.8-1.3-12.9-1.9-22.6-1.9c-27.1,0-63.2,15.5-76.7,35.4V595
H5245z" />
    <path
      style={{ opacity: 0.5 }}
      d="M5815.7,501.7v-186h82.8c32.4,0,52.2,19.5,52.2,47.4c0,23.4-15.6,39-32.6,42.7c19.8,3.1,36.3,23.4,36.3,45.7
c0,29.8-19.8,50.2-53.8,50.2H5815.7z M5926.7,366.5c0-16.7-11.2-30.1-32.1-30.1h-55.8v60h55.8
C5915.5,396.3,5926.7,383.5,5926.7,366.5z M5930.3,449c0-17-11.7-32.1-34.3-32.1h-57.2v64.1h57.2
C5917.5,481.1,5930.3,468.8,5930.3,449z"
    />
    <path
      style={{ opacity: 0.5 }}
      d="M6046.9,501.7v-186h121.9v20.6H6070v60h96.8V417H6070v64.1h98.7v20.6H6046.9z"
    />
    <path
      style={{ opacity: 0.5 }}
      d="M6307.4,501.7V336.4h-58.8v-20.6h141.1v20.6h-59.1v165.4H6307.4z"
    />
    <path
      style={{ opacity: 0.5 }}
      d="M6590.2,501.7l-16.5-41.6h-92.6l-16.5,41.6h-26.5l75-186h28.7l74.7,186H6590.2z M6527.4,339.4l-39.3,100.4h78.9
L6527.4,339.4z"
    />
  </svg>
)



// WEBPACK FOOTER //
// ./src/lib/icons.js